import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, timeout: 20000 });

export const fetchFarm = () => client.get("/farm").then((r) => r.data);
export const fetchStation = (id) => client.get(`/stations/${id}`).then((r) => r.data);
export const fetchObservations = (id, params) =>
    client.get(`/stations/${id}/observations`, { params }).then((r) => r.data);
export const fetchSyncStatus = () => client.get("/sync-status").then((r) => r.data);
export const triggerSync = () => client.post("/sync").then((r) => r.data);
export const fetchThresholds = () => client.get("/settings/thresholds").then((r) => r.data);
export const saveThresholds = (payload) =>
    client.put("/settings/thresholds", payload).then((r) => r.data);
export const resetThresholds = () => client.post("/settings/thresholds/reset").then((r) => r.data);

// Frost
export const fetchFrostHistory = (days = 30) =>
    client.get("/frost-history", { params: { days } }).then((r) => r.data);
export const fetchStationFrost = (id, days = 60) =>
    client.get(`/stations/${id}/frost-events`, { params: { days } }).then((r) => r.data);

// Stations mgmt
export const fetchAvailableStations = () =>
    client.get("/weatherlink/available-stations").then((r) => r.data);
export const addStation = (payload) => client.post("/stations", payload).then((r) => r.data);
export const renameStation = (id, display_name) =>
    client.put(`/stations/${id}`, { display_name }).then((r) => r.data);
export const removeStation = (id) => client.delete(`/stations/${id}`).then((r) => r.data);

// Historical import
export const startImport = (payload) =>
    client.post("/import/historical", payload).then((r) => r.data);
export const getImport = (job_id) =>
    client.get(`/import/historical/${job_id}`).then((r) => r.data);
export const listImports = () => client.get("/import/historical").then((r) => r.data);

// YTD rainfall
export const fetchYtdRainfall = () => client.get("/rainfall/ytd").then((r) => r.data);

// Combined multi-variable weather series (Home page chart)
export const fetchCombined = (range = "24h", station = "all") =>
    client.get("/combined", { params: { range, station } }).then((r) => r.data);
